import { render } from "./ToususList.vue?vue&type=template&id=54b7d840"
import script from "./ToususList.vue?vue&type=script&lang=js"
export * from "./ToususList.vue?vue&type=script&lang=js"

import "./ToususList.vue?vue&type=style&index=0&id=54b7d840&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__